import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { SearchField } from 'src/shared/components/SearchField';
import { type INTEGRATIONS, IntegrationButton } from '../../components/IntegrationButton';
import { IntegrationListWrapper, SearchFieldLabelWrapper } from './styles';
import { useIntegrationsList } from './hooks';

export const IntegrationsList = () => {
  const { t } = useTranslation(['settings']);

  const { companyIntegrationType, handleSearch, isDisabledByLocale, filteredIntegrations } = useIntegrationsList();
  return (
    <Grid2>
      <Grid2 mb={3}>
        <SearchFieldLabelWrapper variant="body1">{t('integrations.select system')}:</SearchFieldLabelWrapper>
      </Grid2>
      <Grid2 mb={4}>
        <SearchField onSearch={handleSearch} sx={{ width: 400 }} />
      </Grid2>
      <IntegrationListWrapper>
        {filteredIntegrations?.map((integrationName: INTEGRATIONS) => {
          const isActive = integrationName === companyIntegrationType;
          const isDisabled = isDisabledByLocale(integrationName);

          return (
            <Box sx={{ display: 'inline-block' }} key={integrationName}>
              <IntegrationButton integrationName={integrationName} isDisabled={isDisabled} isActive={isActive} />
            </Box>
          );
        })}
      </IntegrationListWrapper>
    </Grid2>
  );
};
